var _g, _circle, _path, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgApply(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 216,
    height: 225,
    viewBox: "0 0 216 225",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_639_110)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M116.163 224.269C171.648 224.269 216.628 179.285 216.628 123.793C216.628 68.302 171.648 23.3174 116.163 23.3174C60.6771 23.3174 15.6973 68.302 15.6973 123.793C15.6973 179.285 60.6771 224.269 116.163 224.269Z",
    fill: "#CDDEE0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207.85 7.6153C208.006 7.69915 208.158 7.79108 208.305 7.89075H208.323C208.89 8.29687 209.349 8.83548 209.66 9.45967C209.971 10.0839 210.124 10.7747 210.107 11.4719V11.5079C210.082 12.3477 209.807 13.1608 209.317 13.8433L178.359 57.2064V65.0455L185.539 70.6627L202.305 83.9095C203.043 84.6432 203.628 85.5158 204.026 86.4768C204.425 87.4379 204.63 88.4683 204.628 89.5088V191.266C204.628 193.368 203.794 195.383 202.308 196.869C200.822 198.354 198.807 199.189 196.706 199.189H37.4695C36.4299 199.189 35.4006 198.984 34.4402 198.587C33.4797 198.189 32.6071 197.606 31.872 196.87C31.1369 196.135 30.5538 195.262 30.156 194.302C29.7582 193.341 29.5535 192.312 29.5535 191.272V117.379V111.304L55.7686 49.8377V13.5199H178.341V42.5285L202.341 8.91477C202.941 8.07567 203.825 7.48189 204.828 7.24306C205.832 7.00423 206.888 7.13652 207.802 7.6153H207.85Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.16,
    d: "M48.6667 100.72V70.663L55.7744 65.0518V107.828L48.6667 100.72Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.16,
    d: "M185.467 100.726V70.663L178.365 65.0518V107.828L185.467 100.726Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.772 196.284L128.444 125.343C125.288 122.614 121.256 121.112 117.085 121.112C112.913 121.112 108.881 122.614 105.726 125.343L29.5713 191.217",
    stroke: "black",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.03 141.166L202.269 83.9216L202.281 83.9097",
    stroke: "black",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.8767 83.9097V83.9157L88.3368 140.376",
    stroke: "black",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.8706 83.9097C31.1348 84.6445 30.5513 85.5173 30.1537 86.4782C29.756 87.4391 29.552 88.4691 29.5533 89.509V191.243C29.5493 192.285 29.7512 193.317 30.1472 194.281C30.5433 195.245 31.1258 196.122 31.8612 196.86C32.5967 197.598 33.4707 198.184 34.433 198.584C35.3954 198.984 36.4272 199.189 37.4693 199.189H196.706C198.807 199.189 200.822 198.355 202.308 196.869C203.793 195.383 204.628 193.368 204.628 191.267V89.509C204.629 88.4685 204.425 87.4381 204.026 86.477C203.627 85.516 203.042 84.6434 202.305 83.9097",
    stroke: "black",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.7745 65.0518L31.8767 83.9157L31.8647 83.9217",
    stroke: "black",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.269 83.9217L178.365 65.0518",
    stroke: "black",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.365 107.829V13.4849H55.7744V107.811",
    stroke: "black",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.2839 81.7599L37.9005 94.3778L64.3731 67.9023",
    stroke: "black",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.804 30.3647H160.647",
    stroke: "black",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.7556 54.3203H160.647",
    stroke: "black",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.7798 72.2856H160.647",
    stroke: "black",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.7798 108.217H136.695",
    stroke: "black",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.317 13.8549L147.952 99.8087L136.695 108.193L140.994 94.8142L202.359 8.86042C202.685 8.40014 203.099 8.00913 203.578 7.70978C204.056 7.41043 204.589 7.20875 205.146 7.11634C205.702 7.02392 206.272 7.04257 206.821 7.17131C207.37 7.30004 207.889 7.53627 208.346 7.86637C208.805 8.19469 209.194 8.61042 209.491 9.08966C209.788 9.56891 209.987 10.1021 210.077 10.6587C210.168 11.2153 210.147 11.7843 210.016 12.3328C209.886 12.8813 209.648 13.3987 209.317 13.8549Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.16,
    d: "M207.562 12.6031L146.198 98.5809L137.779 104.869L136.695 108.246L147.952 99.8624L209.317 13.9087C209.7 13.3782 209.956 12.7663 210.064 12.1208C210.172 11.4753 210.13 10.8136 209.94 10.1871C209.751 9.56058 209.419 8.98627 208.971 8.50893C208.523 8.0316 207.972 7.66409 207.358 7.43506C207.953 8.1556 208.295 9.05122 208.332 9.98473C208.368 10.9182 208.098 11.838 207.562 12.6031Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.317 13.8549L147.952 99.8087L136.695 108.193L140.994 94.8142L202.359 8.86042C202.685 8.40014 203.099 8.00913 203.578 7.70978C204.056 7.41043 204.589 7.20875 205.146 7.11634C205.702 7.02392 206.272 7.04257 206.821 7.17131C207.37 7.30004 207.889 7.53627 208.346 7.86637V7.86637C208.805 8.19469 209.194 8.61042 209.491 9.08966C209.788 9.56891 209.987 10.1021 210.077 10.6587C210.168 11.2153 210.147 11.7843 210.016 12.3328C209.886 12.8813 209.648 13.3987 209.317 13.8549V13.8549Z",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 42.7856,
    cy: 80.9575,
    r: 36.1035,
    fill: "black"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M42.0769 90V75.596L39.0869 76.298V73.75L43.4809 71.8H45.5349V90H42.0769Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_639_110"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 215.963,
    height: 224.269,
    fill: "white",
    transform: "translate(0.0371094)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgApply);
export default __webpack_public_path__ + "static/media/Apply.821224551e6fc8f3fb99a8a1c6ffb391.svg";
export { ForwardRef as ReactComponent };